import { Props } from 'react-joyride'

export const onboardingConfig: Partial<Props> = {
  styles: {
    options: {
      primaryColor: '#FF6133',
    },
  },
  locale: {
    back: 'Wstecz',
    close: 'Zamknij',
    last: 'Zakończ',
    next: 'Dalej',
    skip: 'Pomiń',
    open: 'Wyświetl szczegóły',
  },
}
